module.exports = __webpack_public_path__ + "static/media/pourquoi_goodypack_fr.d6c1c0cf.png";